/* eslint-disable
    block-scoped-var,
    no-eq-null,
    no-use-before-define,
    no-var,
*/
import last from 'lodash/last'
import moment from 'moment'

export default potDivision

/** @ngInject */
function potDivision(ReportManager) {
    return ({
        scope: {
            pot: '=',
            userInfo: '=',
        },
        restrict: 'E',
        template: require('./view.jade')(),
        link($scope) {
            $scope.realVisible = $scope.pot.real !== undefined
            const contract = $scope.userInfo.contractSelected

            const getLatestReadMonthIndex = function (dateMonths, lastReadings) {
                const date = lastReadings ? moment(lastReadings[0] != null ? lastReadings[0].end_date : undefined) : moment()
                for (let index = 0; index < dateMonths.length; index++) {
                    const month = dateMonths[index]
                    if (date.isSame(month, 'month')) {
                        return date.date() >= 25 ? index + 1 : index
                    }
                }
                return date.isAfter(last(dateMonths), 'month') ? dateMonths.length : 0
            }

            // Compute visual elements from data
            $scope.computeFromColorIndex = function (interval, month, colorIndex) {
                // In case there is an inconsistency in the data returned by the API
                if (interval < 0) {
                    $scope.colored = []
                    $scope.coloredWidth = 0
                    $scope.coloredMonthWidth = 0

                    $scope.uncolored = []
                    $scope.uncoloredWidth = 0
                    $scope.uncoloredMonthWidth = 0
                    console.error(`Inconsistent data : month interval is "${interval}" but should be positive`)
                }
                $scope.colored = months.slice(0, colorIndex)
                $scope.coloredWidth = $scope.colored.length * $scope.monthWidth
                $scope.coloredMonthWidth = 100 / $scope.colored.length

                $scope.uncolored = months.slice(colorIndex)
                $scope.uncoloredWidth = $scope.uncolored.length * $scope.monthWidth
                $scope.uncoloredMonthWidth = 100 / $scope.uncolored.length
            }

            if (contract != null) {
                const nextReadingDate = moment(contract.prm.next_reading_date)
                const commissioningDate = contract.commissioning_date ? moment(contract.commissioning_date) : undefined
                const lastReadingDate = contract.prm.last_real_reading_date ? moment(contract.prm.last_real_reading_date).add(1, 'month') : undefined
                const startDate = lastReadingDate || (commissioningDate || moment())
                const period = ((nextReadingDate.year() * 12) + nextReadingDate.month()) - ((startDate.year() * 12) + startDate.month())
                const interval = Math.min(period, 5)

                // Populates an array with the name of the months
                var months = []
                const dateMonths = []
                for (let i = 0, end = interval, asc = end >= 0; asc ? i <= end : i >= end; asc ? i += 1 : i -= 1) {
                    dateMonths[i] = startDate.clone().add(i, 'months')
                    months[i] = dateMonths[i].format('MMM')
                }

                $scope.startDate = startDate.clone()
                $scope.endDate = nextReadingDate
                $scope.monthWidth = 100 / (1 + interval)

                let colorIndex = getLatestReadMonthIndex(dateMonths, ReportManager.values)
                $scope.computeFromColorIndex(interval, months, colorIndex)

                // Watch for values to change on report
                return ReportManager.watch((contract) => {
                    colorIndex = getLatestReadMonthIndex(dateMonths, contract != null ? contract.lastReadings : undefined)
                    return $scope.computeFromColorIndex(interval, months, colorIndex)
                })
            }
        },
    })
}



// WEBPACK FOOTER //
// ./src/directives/pot-division/directive.js